import { useRouter } from 'next/router'
import { ReactElement, useMemo } from 'react'

function useNestedRoute(routesConfig: Record<string, () => ReactElement>): (() => ReactElement) | null {
	const router = useRouter()
	const nestedRoute = useMemo(() => (router.query.subpath as string[] | undefined)?.join('/'), [router.query])

	return nestedRoute ? routesConfig[nestedRoute as keyof typeof routesConfig] : null
}

export default useNestedRoute
